import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, CallTo } from 'components/common';

import { withTranslation } from 'language/i18n';
import { verifyEmail } from 'models/user';
import { StatusContext } from 'contexts/statusContext';

const EmailVerification = ({ t, userState }) => {
  const { setErrorState } = useContext(StatusContext);

  const [onResponse, setOnResponse] = useState(false);
  const [time, setTime] = useState(180);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(time - 1);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [time]);

  const onFormSubmit = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        await verifyEmail(userState.email);
        setTime(180);
        setErrorState({
          title: t('successful'),
          type: 'success',
          text: 'Aktivasyon linki E-Posta adresinize gönderildi.',
          buttonText: t('close'),
          onClickButton: () => setErrorState({}),
        });
      } catch (error) {
        console.log('onVerifyEmailErr', error);
        if (error.status) {
          setErrorState({
            title: t('alert'),
            text: error.message,
            buttonText: t('close'),
            onClickButton: () => setErrorState({}),
          });
        }
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <div className="col-md-10 col-lg-8 offset-lg-1 mt-5 mt-lg-0">
      <Form layout="vertical" onFinish={onFormSubmit}>
        <div className="fs-22 mb-2">{t('stepNumber', { step: 3 })}</div>
        <div className="fs-22 fw-900 mb-3">{t('verifyYourEmailAddress')}</div>
        <p>
          Üyelik işleminizin tamamlanması için gerekli aktivasyon linki
          {' '}
          <span className="fw-700">{userState.email}</span>
          {' '}
          e-posta adresinize gönderilmiştir.
        </p>
        <p className="mt-3">
          Aktivasyon linki 3 dakika içerisinde e-posta adresinize ulaşmazsa tekrar gönderilmesi için aşağıdaki butona tıklayınız.
        </p>
        <Button
          loading={onResponse}
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center"
          disabled={time > 0}
          label={t('sendAgain')}
        />
        <div className="row text-center mt-4">
          <div className="col">
            {time > 0 && <p className="fw-700">{t('waitForSendCode', { time })}</p>}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <p className="fw-700">{t('didntReceiveVerificationEmail')}</p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <p className="fw-400">
              Bize
              {' '}
              <CallTo style={{ fontWeight: '700', color: '#4d4e4e' }} tel="+90 (850) 885 46 25" />
              {' '}
              numaralı telefondan ulaşarak e-posta doğrulamasını yapabilirsiniz.
            </p>
          </div>
        </div>
      </Form>
    </div>
  );
};

EmailVerification.propTypes = {
  t: PropTypes.func,
  userState: PropTypes.object,
};

export default withTranslation('common')(EmailVerification);
